import React from "react";
import { Eye, Check } from "lucide-react";
import Modal from "@/components/app/Modal";
import { assetUrl } from "@/lib/api";
import { btnPrimary } from "@/components/app/ui";

/** Card image of a theme: the super admin's preview picture when there is one, otherwise a colour swatch. */
export function ThemeThumb({ t, height = 96, onPreview }) {
  return (
    <div className="relative group" style={{ height }}>
      {t.preview_image
        ? <img src={assetUrl(t.preview_image)} alt={`${t.name} preview`} loading="lazy" className="w-full h-full object-cover object-top" data-testid={`theme-thumb-${t.id}`} />
        : <div className="w-full h-full" style={{ background: `linear-gradient(135deg, ${t.colors.primary}, ${t.colors.accent})` }} />}
      {t.preview_image && onPreview && (
        <span role="button" tabIndex={0} onClick={(e) => { e.stopPropagation(); onPreview(t); }} onKeyDown={(e) => { if (e.key === "Enter") { e.stopPropagation(); onPreview(t); } }}
          data-testid={`theme-preview-open-${t.id}`} aria-label={`Preview ${t.name}`}
          className="absolute right-1.5 bottom-1.5 inline-flex items-center gap-1 h-7 px-2 rounded-md bg-white/95 text-[11px] font-semibold text-neutral-800 shadow hover:bg-white">
          <Eye size={12} /> Preview
        </span>
      )}
    </div>
  );
}

/** Full-size preview of a theme with an optional "use this theme" action. */
export default function ThemePreviewModal({ theme, onClose, onUse, selected }) {
  if (!theme) return null;
  return (
    <Modal open onClose={onClose} size="xl" testId="theme-preview-modal" title={`${theme.name} — preview`} subtitle={`${theme.category} · ${theme.font}`}
      footer={<>
        <button onClick={onClose} className="h-9 px-4 rounded-lg border border-slate-300 bg-white text-[13px] font-semibold text-neutral-800 hover:border-blue-300">Close</button>
        {onUse && <button onClick={() => { onUse(theme); onClose(); }} data-testid="theme-preview-use" className={btnPrimary}>{selected ? <><Check size={14} /> Selected</> : "Use this theme"}</button>}
      </>}>
      <div className="rounded-lg border border-slate-200 overflow-hidden bg-slate-50">
        <img src={assetUrl(theme.preview_image)} alt={`${theme.name} full preview`} className="w-full h-auto block" />
      </div>
    </Modal>
  );
}
